import React from 'react'
import styled from 'styled-components'
import cn from 'clsx'

const Container = styled.div`
  position: relative;
  width: auto;
  height: auto;
`

const TEARDROP_PIN_WIDTH = 27.5
const TEARDROP_PIN_HEIGHT = 31.25

const StyledSvg = styled.svg`
  pointer-events: none;
  overflow: visible;

  & > path {
    pointer-events: all;
    cursor: pointer;
  }

  width: ${TEARDROP_PIN_WIDTH}px;
  height: ${TEARDROP_PIN_HEIGHT}px;

  transition: transform 0.2s;
  &:hover, &.isActive {
    transform: scale(1.25);
  }
`

const ColouredPinPath = styled.path`
  stroke: ${(props) => props.theme.palette.neutral.default.five};
  fill: ${(props) => props.theme.palette.neutral.default.eight};
`

const ColouredHeartPath = styled.path`
  fill: ${(props) => props.theme.palette.messaging.favourite.normalForeground};
`

interface Props {
  isActive: boolean
}

function SearchCustomPin({ isActive }: Props) {
  return (
    <Container>
      <StyledSvg viewBox="0 0 36 45" className={cn({ isActive })}>
        <ColouredPinPath d="M31.662 28.9373L31.0104 29.75H31.1233L18.3708 43.845C18.1723 44.0643 17.8278 44.0643 17.6293 43.845L4.87666 29.75H4.98955L4.33804 28.9373C1.93628 25.9412 0.5 22.139 0.5 18C0.5 8.33502 8.33502 0.5 18 0.5C27.665 0.5 35.5 8.33502 35.5 18C35.5 22.139 34.0637 25.9412 31.662 28.9373Z"/>
        <ColouredHeartPath d="M25.4999 14.1038C25.1249 12.6788 23.6999 11.3288 21.7499 11.2538C19.8749 11.1788 18.8249 12.2288 17.9999 13.2038C17.1749 12.2288 16.1249 11.1788 14.2499 11.2538C12.2999 11.3288 10.9499 12.6038 10.4999 14.1038C9.67489 17.2538 11.6249 18.6788 11.9999 19.1288C13.3499 20.5538 17.3999 24.9038 17.3999 24.9038C17.4749 24.9788 17.5499 25.0538 17.6249 25.0538C17.6999 25.1288 17.8499 25.1288 17.9249 25.1288C17.9999 25.1288 18.1499 25.1288 18.2249 25.0538C18.2999 24.9788 18.3749 24.9788 18.4499 24.9038C18.4499 24.9038 22.4999 20.5538 23.8499 19.1288C24.3749 18.6038 26.3249 17.2538 25.4999 14.1038Z"/>
      </StyledSvg>
    </Container>
  )
}

export default SearchCustomPin
